import {writable} from "svelte/store";

export const initialSaleDetail = () => {
    return {
        recipient : '',
        reserveToken: '',
        coolDownDuration: '',
        raiseTarget: '' ,
        capPerWallet: '',
        forwardingAddress: '',
        startDateAndTime: '',
        endDateAndTime: '',
    }
}


const projectSalePermissionless = () => {
    const { subscribe, update, set } = writable(initialSaleDetail())

    return {
        subscribe,
        setProjectSaleDetail: ({...fields}) => update(n => ({...n, ...fields })),
        reset: () => set(initialSaleDetail())
    }
}

export const projectSaleStore = projectSalePermissionless()